// Auto-generated background presets - DO NOT EDIT
// Generated: 2026-02-01T15:23:48.512Z

import type { BackgroundPreset } from '@/types';
import type { Gender } from '@/types/character';

// Female background presets
export const FEMALE_BACKGROUND_PRESETS: BackgroundPreset[] = [
  {
    id: 'solid-white',
    name: 'Solid White',
    thumbnailUrl: `https://cdn-cms-uploads.picsart.com/cms-uploads/54f1d130-c936-48de-a175-47988d36eaa8.png`,
    prompt: `Solid pure white background (#FFFFFF).
        Seamless, perfectly even, no gradients, no shadows.
        Clean professional studio backdrop.
        16:9 aspect ratio.`,
  },
  {
    id: 'studio-gray',
    name: 'Studio Gray',
    thumbnailUrl: `https://cdn-cms-uploads.picsart.com/cms-uploads/8006bd3a-cafd-46fa-a01d-e9a3c5b9f49d.png`,
    prompt: `Solid neutral light gray background (#E5E5E5).
        Seamless studio backdrop, perfectly even.
        Clean professional photography background.
        16:9 aspect ratio.`,
  },
  {
    id: 'solid-cream',
    name: 'Solid Cream',
    thumbnailUrl: `https://cdn-cms-uploads.picsart.com/cms-uploads/0728a586-f8c5-472d-9a94-79b10dd50ebe.png`,
    prompt: `Solid warm cream background (#FFF8E7).
        Seamless, perfectly even, no gradients.
        Elegant soft studio backdrop.
        16:9 aspect ratio.`,
  },
  {
    id: 'solid-pink',
    name: 'Solid Pink',
    thumbnailUrl: `https://cdn-cms-uploads.picsart.com/cms-uploads/2433d55d-e64b-4c71-9925-994493785fa4.png`,
    prompt: `Solid soft blush pink background (#FFE4E6).
        Seamless, perfectly even, no gradients.
        Clean feminine studio backdrop.
        16:9 aspect ratio.`,
  },
  {
    id: 'gradient-lavender',
    name: 'Lavender Gradient',
    thumbnailUrl: `https://cdn-cms-uploads.picsart.com/cms-uploads/0f4704fe-2652-403d-ace8-69873b0559e5.png`,
    prompt: `Smooth lavender gradient background.
        Transition from soft lavender (#E6E6FA) to white (#FFFFFF).
        Seamless vertical gradient, no texture.
        16:9 aspect ratio.`,
  },
  {
    id: 'gradient-rose',
    name: 'Rose Gradient',
    thumbnailUrl: `https://cdn-cms-uploads.picsart.com/cms-uploads/35d48b6f-0e5c-4184-8ba8-4336ac60aa89.png`,
    prompt: `Smooth rose gradient background.
        Transition from dusty rose (#D4A5A5) to soft cream (#FFF8F0).
        Seamless vertical gradient, no texture.
        16:9 aspect ratio.`,
  },
  {
    id: 'gradient-sunset',
    name: 'Sunset Gradient',
    thumbnailUrl: `https://cdn-cms-uploads.picsart.com/cms-uploads/e1744df8-4ebe-4c22-a871-b1e0f04f12f6.png`,
    prompt: `Smooth sunset gradient background.
        Transition from warm coral (#FF7F7F) to golden peach (#FFDAB9).
        Seamless vertical gradient, dreamy atmosphere.
        16:9 aspect ratio.`,
  },
  {
    id: 'solid-peach',
    name: 'Solid Peach',
    thumbnailUrl: `https://cdn-cms-uploads.picsart.com/cms-uploads/70357a7a-42c1-42c7-be24-9271bb54ecda.png`,
    prompt: `Solid warm peach background (#FFDAB9).
        Seamless, perfectly even, no gradients.
        Soft romantic studio backdrop.
        16:9 aspect ratio.`,
  },
  {
    id: 'nature-meadow',
    name: 'Meadow Bokeh',
    thumbnailUrl: `https://cdn-cms-uploads.picsart.com/cms-uploads/6fefc4dc-d2a4-476c-9545-c03ed18a58ff.png`,
    prompt: `Blurred meadow wildflower background.
        Out-of-focus wildflowers, soft grass, golden hour light.
        Soft bokeh effect, pastoral romantic atmosphere.
        16:9 aspect ratio.`,
  },
  {
    id: 'gradient-ocean',
    name: 'Ocean Gradient',
    thumbnailUrl: `https://cdn-cms-uploads.picsart.com/cms-uploads/1560bd96-0cb6-40ff-b804-8da39db73cd8.png`,
    prompt: `Smooth ocean gradient background.
        Transition from soft teal (#B2DFDB) to seafoam green (#E0F2F1).
        Seamless vertical gradient, calming tones.
        16:9 aspect ratio.`,
  },
  {
    id: 'studio-marble',
    name: 'Marble Texture',
    thumbnailUrl: `https://cdn-cms-uploads.picsart.com/cms-uploads/426af51c-2fc7-4adf-9546-cbd08cd905ca.png`,
    prompt: `Blurred white marble texture background.
        Out-of-focus elegant marble pattern, soft veining.
        Subtle texture, luxury minimalist aesthetic.
        16:9 aspect ratio.`,
  },
  {
    id: 'nature-garden',
    name: 'Garden Bokeh',
    thumbnailUrl: `https://cdn-cms-uploads.picsart.com/cms-uploads/dc3c2fdc-2d93-4d3b-a5a0-a8ba970f9dda.png`,
    prompt: `Blurred flower garden background.
        Out-of-focus colorful flowers and greenery.
        Soft bokeh effect, romantic natural light.
        16:9 aspect ratio, outdoor photography backdrop.`,
  },
  {
    id: 'nature-beach',
    name: 'Beach Sunset',
    thumbnailUrl: `https://cdn-cms-uploads.picsart.com/cms-uploads/0ee048f2-e9ce-43ff-8715-ad8aa8711f2b.png`,
    prompt: `Blurred beach at golden hour background.
        Out-of-focus sand, ocean waves, warm sunset colors.
        Soft bokeh effect, dreamy vacation atmosphere.
        16:9 aspect ratio, lifestyle photography backdrop.`,
  },
  {
    id: 'urban-cafe',
    name: 'Cafe Ambiance',
    thumbnailUrl: `https://cdn-cms-uploads.picsart.com/cms-uploads/2c931299-937d-40d5-b055-594e45f7a557.png`,
    prompt: `Blurred cozy cafe background.
        Out-of-focus warm lights, coffee shop ambiance.
        Soft bokeh effect, warm inviting tones.
        16:9 aspect ratio, lifestyle photography backdrop.`,
  },
  {
    id: 'urban-cityscape',
    name: 'City Night Bokeh',
    thumbnailUrl: `https://cdn-cms-uploads.picsart.com/cms-uploads/68f0734a-ed19-4b5a-984e-f26de20edd60.png`,
    prompt: `Blurred city at night background.
        Out-of-focus city lights, bokeh orbs, urban glow.
        Dreamy night atmosphere, elegant evening vibe.
        16:9 aspect ratio.`,
  },
  {
    id: 'nature-cherry',
    name: 'Cherry Blossom',
    thumbnailUrl: `https://cdn-cms-uploads.picsart.com/cms-uploads/1533c478-5a25-4622-9a88-5fd7f92699e0.png`,
    prompt: `Blurred cherry blossom background.
        Out-of-focus pink cherry blossoms, spring atmosphere.
        Soft bokeh effect, romantic Japanese aesthetic.
        16:9 aspect ratio.`,
  },
];

// Male background presets
export const MALE_BACKGROUND_PRESETS: BackgroundPreset[] = [
  {
    id: 'solid-white',
    name: 'Solid White',
    thumbnailUrl: `https://cdn-cms-uploads.picsart.com/cms-uploads/54f1d130-c936-48de-a175-47988d36eaa8.png`,
    prompt: `Solid pure white background (#FFFFFF).
        Seamless, perfectly even, no gradients, no shadows.
        Clean professional studio backdrop.
        16:9 aspect ratio.`,
  },
  {
    id: 'studio-light-gray',
    name: 'Studio Light Gray',
    thumbnailUrl: `https://cdn-cms-uploads.picsart.com/cms-uploads/de6579e0-1d8d-4ae8-ad2d-a443d3c156e1.png`,
    prompt: `Solid neutral light gray background (#D4D4D4).
        Seamless studio backdrop, perfectly even.
        Clean professional photography background.
        16:9 aspect ratio.`,
  },
  {
    id: 'solid-gray',
    name: 'Solid Gray',
    thumbnailUrl: `https://cdn-cms-uploads.picsart.com/cms-uploads/d680bb3b-c615-49cc-ac28-2c862bedd4ba.png`,
    prompt: `Solid neutral charcoal gray background (#4A4A4A).
        Seamless, perfectly even, no gradients.
        Clean masculine studio backdrop.
        16:9 aspect ratio.`,
  },
  {
    id: 'solid-black',
    name: 'Solid Black',
    thumbnailUrl: `https://cdn-cms-uploads.picsart.com/cms-uploads/a4c260c7-9f42-4910-80eb-f0db3f7334f3.png`,
    prompt: `Solid pure black background (#000000).
        Seamless, perfectly even, no gradients.
        Dramatic studio backdrop.
        16:9 aspect ratio.`,
  },
  {
    id: 'gradient-steel',
    name: 'Steel Gradient',
    thumbnailUrl: `https://cdn-cms-uploads.picsart.com/cms-uploads/1a395a27-4fda-48e9-9bc5-fc3707f651d0.png`,
    prompt: `Smooth steel gradient background.
        Transition from dark charcoal (#2C2C2C) to silver gray (#9CA3AF).
        Seamless vertical gradient, no texture.
        16:9 aspect ratio.`,
  },
  {
    id: 'gradient-navy',
    name: 'Navy Gradient',
    thumbnailUrl: `https://cdn-cms-uploads.picsart.com/cms-uploads/e4b07f7c-07e5-4434-ad92-6d133dcbefff.png`,
    prompt: `Smooth navy gradient background.
        Transition from deep navy (#1E3A5F) to lighter blue (#4A6FA5).
        Seamless vertical gradient, no texture.
        16:9 aspect ratio.`,
  },
  {
    id: 'solid-navy',
    name: 'Solid Navy',
    thumbnailUrl: `https://cdn-cms-uploads.picsart.com/cms-uploads/947c5b1c-f03c-4637-ad24-44c2fd50e08d.png`,
    prompt: `Solid deep navy blue background (#1E3A5F).
        Seamless, perfectly even, no gradients.
        Professional masculine studio backdrop.
        16:9 aspect ratio.`,
  },
  {
    id: 'gradient-bronze',
    name: 'Bronze Gradient',
    thumbnailUrl: `https://cdn-cms-uploads.picsart.com/cms-uploads/6bae434f-3912-4484-81f2-c65c679060db.png`,
    prompt: `Smooth bronze gradient background.
        Transition from dark bronze (#8B4513) to warm tan (#D2B48C).
        Seamless vertical gradient, warm masculine tones.
        16:9 aspect ratio.`,
  },
  {
    id: 'nature-mountain',
    name: 'Mountain Bokeh',
    thumbnailUrl: `https://cdn-cms-uploads.picsart.com/cms-uploads/ba0954b3-1e50-41ec-b04a-bc6539f81096.png`,
    prompt: `Blurred mountain landscape background.
        Out-of-focus mountain peaks, natural earth tones.
        Soft bokeh effect, adventure atmosphere.
        16:9 aspect ratio.`,
  },
  {
    id: 'solid-olive',
    name: 'Solid Olive',
    thumbnailUrl: `https://cdn-cms-uploads.picsart.com/cms-uploads/5cc30dbc-babc-4f58-892a-ba8d463f5030.png`,
    prompt: `Solid olive green background (#556B2F).
        Seamless, perfectly even, no gradients.
        Earth tone masculine studio backdrop.
        16:9 aspect ratio.`,
  },
  {
    id: 'studio-concrete',
    name: 'Concrete Texture',
    thumbnailUrl: `https://cdn-cms-uploads.picsart.com/cms-uploads/ac457792-9c48-40c9-b144-c0b616b67776.png`,
    prompt: `Blurred concrete texture background.
        Out-of-focus industrial concrete, subtle texture.
        Modern minimalist aesthetic, raw urban feel.
        16:9 aspect ratio.`,
  },
  {
    id: 'nature-forest',
    name: 'Forest Bokeh',
    thumbnailUrl: `https://cdn-cms-uploads.picsart.com/cms-uploads/f6c36e60-d46c-498d-9152-d674247a92a7.png`,
    prompt: `Blurred forest background.
        Out-of-focus trees, natural green foliage.
        Soft bokeh effect, dappled natural light.
        16:9 aspect ratio, outdoor photography backdrop.`,
  },
  {
    id: 'gym-industrial',
    name: 'Industrial Gym',
    thumbnailUrl: `https://cdn-cms-uploads.picsart.com/cms-uploads/c003a82f-43a0-4c47-98f2-425f03e5c6b0.png`,
    prompt: `Blurred industrial gym background.
        Out-of-focus weights, concrete walls, raw aesthetic.
        Soft bokeh effect, dramatic lighting.
        16:9 aspect ratio, athletic photography backdrop.`,
  },
  {
    id: 'urban-night',
    name: 'City Night Bokeh',
    thumbnailUrl: `https://cdn-cms-uploads.picsart.com/cms-uploads/6a0a1ec5-d845-4e8d-a535-997ed4fddb10.png`,
    prompt: `Blurred city at night background.
        Out-of-focus city lights, neon bokeh orbs, urban glow.
        Dramatic night atmosphere, modern urban vibe.
        16:9 aspect ratio.`,
  },
  {
    id: 'urban-street',
    name: 'Urban Street',
    thumbnailUrl: `https://cdn-cms-uploads.picsart.com/cms-uploads/90866210-1c7b-49a5-bd9d-dc396dd1c79a.png`,
    prompt: `Blurred urban street background.
        Out-of-focus city buildings, concrete, industrial elements.
        Soft bokeh effect, cool urban tones.
        16:9 aspect ratio, streetwear photography backdrop.`,
  },
  {
    id: 'urban-warehouse',
    name: 'Warehouse Industrial',
    thumbnailUrl: `https://cdn-cms-uploads.picsart.com/cms-uploads/59ca4d80-6b7b-471a-bfce-2062a5ba5d50.png`,
    prompt: `Blurred warehouse background.
        Out-of-focus brick walls, industrial fixtures.
        Soft bokeh effect, raw aesthetic atmosphere.
        16:9 aspect ratio.`,
  },
];

// Get background presets by gender
export function getBackgroundPresetsByGender(gender: Gender): BackgroundPreset[] {
  switch (gender) {
    case 'female':
      return FEMALE_BACKGROUND_PRESETS;
    case 'male':
      return MALE_BACKGROUND_PRESETS;
    default:
      return FEMALE_BACKGROUND_PRESETS;
  }
}

// Legacy export (defaults to female)
export const GENERATED_BACKGROUND_PRESETS = FEMALE_BACKGROUND_PRESETS;
